import { useCallback, useEffect, useState } from 'react';
import { useIsMobile } from './useIsMobile';

/**
 * Shared state for the mobile sidebar drawer used by every page that renders
 * `<ConversationSidebar>` inside the `.chat-layout` shell (chat + projects). On
 * mobile the sidebar is an off-canvas drawer; this bundles the breakpoint check,
 * the open/closed state, and Escape-to-close (matching the SearchModal convention).
 */
export function useMobileNav() {
  const isMobile = useIsMobile();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const openNav = useCallback(() => setMobileNavOpen(true), []);
  const closeNav = useCallback(() => setMobileNavOpen(false), []);

  useEffect(() => {
    if (!mobileNavOpen) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setMobileNavOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [mobileNavOpen]);

  return { isMobile, mobileNavOpen, openNav, closeNav };
}
